<template>
  <div>
    <slot :open="open">
      <button 
        class="cx-btn" 
        @click="show=true"
      >{{$t('media.share')}}</button>
    </slot>
    <div class="cx-modal--full" v-if="show" v-trap-focus="{escFunc: dismiss }">
      <div class="cx-modal__body">
        <div class="cx-card--notify">
          <div class="cx-wrap--article">
            <div>
              <img v-if="qrCodeDataUrl" :src="qrCodeDataUrl" alt="QR code">
            </div>
            <div class="cx-div">
              <div class="cx-t20">{{$t('media.shareHeading')}}</div>
              <div class="cx-t01 -fade share-url" @click="copyUrl">{{url}}</div>
              <input type="hidden" :value="url" ref="url">
            </div>
            <div class="cx-div share-btn-list">
              <a ref="focus"
                :href="`https://www.facebook.com/sharer/sharer.php?u=${url}`"
                rel="noopener noreferrer" target="_blank"
                class="cx-btn cx-brand-facebook"
                title="Share to Facebook">
                <span class="cx-btn__icon">
                  <i class="fab fa-fw fa-facebook"></i>
                </span>
                <span>Facebook</span>
              </a>
              <a :href="`http://vk.com/share.php?url=${url}`" 
                rel="noopener noreferrer" target="_blank"
                class="cx-btn cx-brand-vk" 
                title="Share to VK">
                <span class="cx-btn__icon">
                  <i class="fab fa-fw fa-vk"></i> 
                </span>
                <span>VK</span>
              </a>
              <a v-if="isMobile" 
                :href="`fb-messenger://share/?link=${url}`" 
                rel="noopener noreferrer" target="_blank"
                class="cx-btn cx-brand-facebook-messenger" 
                title="Send to Messenger">
                <span class="cx-btn__icon">
                  <i class="fab fa-fw fa-facebook-messenger"></i> 
                </span>
                <span>Messenger</span>
              </a>
              <a :href="`https://telegram.me/share/url?url=${url}`" 
                rel="noopener noreferrer" target="_blank"
                class="cx-btn cx-brand-telegram"
                title="Send to Telegram">
                <span class="cx-btn__icon">
                  <i class="fab fa-fw fa-telegram"></i> 
                </span>
                <span>Telegram</span>
              </a>
              <a :href="`https://www.linkedin.com/shareArticle?url=${url}`" 
                rel="noopener noreferrer" target="_blank"
                class="cx-btn cx-brand-linkedin"
                title="Share to LinkedIn">
                <span class="cx-btn__icon">
                  <i class="fab fa-fw fa-linkedin"></i> 
                </span>
                <span>LinkedIn</span>
              </a>
              <a :href="`https://twitter.com/intent/tweet?url=${url}`"
                rel="noopener noreferrer" target="_blank"
                class="cx-btn cx-brand-twitter" title="Share to Twitter">
                <span class="cx-btn__icon">
                  <i class="fab fa-fw fa-x-twitter"></i>
                </span>
                <span>Twitter</span>
              </a>
              <a :href="`https://service.weibo.com/share/share.php?url=${url}`"
                rel="noopener noreferrer" target="_blank"
                class="cx-btn cx-brand-sinaweibo" title="Share to Sina Weibo">
                <span class="cx-btn__icon">
                  <i class="fab fa-fw fa-weibo"></i>
                </span>
                <span>Sina Weibo</span>
              </a>
              <a :href="`https://lineit.line.me/share/ui?url=${url}`"
                rel="noopener noreferrer" target="_blank"
                class="cx-btn cx-brand-line"
                title="Send to Line">
                <span class="cx-btn__icon">
                  <i class="fab fa-fw fa-line"></i> 
                </span>
                <span>Line</span>
              </a>
              <a :href="`http://sns.qzone.qq.com/cgi-bin/qzshare/cgi_qzshare_onekey?url=${url}`"
                rel="noopener noreferrer" target="_blank"
                class="cx-btn cx-brand-qq" 
                title="Share to Qzone">
                <span class="cx-btn__icon">
                  <i class="fab fa-fw fa-qq"></i> 
                </span>
                <span>Qzone</span>
              </a>
              <a :href="`https://plus.google.com/share?url=${url}`" 
                rel="noopener noreferrer" target="_blank"
                class="cx-btn cx-brand-googleplus" 
                title="Share to Google Plus">
                <span class="cx-btn__icon">
                  <i class="fab fa-fw fa-google-plus"></i> 
                </span>
                <span>Google Plus</span>
              </a>
              <a :href="`http://pinterest.com/pin/create/link/?url=${url}`"
                rel="noopener noreferrer" target="_blank"
                class="cx-btn cx-brand-pinterest" 
                title="Share to Pinterest">
                <span class="cx-btn__icon">
                  <i class="fab fa-fw fa-pinterest"></i> 
                </span>
                <span>Pinterest</span>
              </a>
            </div>
            <div class="cx-div">
              <a href="#" class="cx-link"
                @click.prevent="dismiss">
                <span class="cx-link__icon"><i class="fal fa-ban"></i></span>
                <span>{{$t('action.cancel')}}</span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import qr from 'qrcode';

export default {
  name: 'share-modal',
  uit() {
    return [
      ['media', ['shareHeading']],
      ['action', ['cancel']],
    ]
  },
  props: {
    extralLink: {
      type: Boolean,
      default: false,
    },
    shareUrl: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      show: false,
      isMobile: false,
      url: '',
      qrCodeDataUrl: '',
    }
  },
  mounted() {
    this.isMobile = this.checkIsMobile();
    this.hostname = `${window.location.protocol}//${window.location.hostname}/${this.$i18n.locale}`;
    this.updateUrl();
  },
  methods: {
    dismiss: function() {
      this.show = false;
    },
    updateUrl: function() {
      this.url = this.extralLink ? this.shareUrl : `${this.hostname}/${this.shareUrl}`
      this.generateQrCode();
    },
    generateQrCode: function() {
      if (!this.url || typeof window === 'undefined') {
        return;
      }

      qr.toDataURL(this.url, { width: 250, margin: 1 })
        .then((dataUrl) => {
          this.qrCodeDataUrl = dataUrl;
        })
        .catch(() => {
          this.qrCodeDataUrl = '';
        });
    },
    open: function() {
      this.show = true;
      this.$refs.focus && this.$refs.focus.focus();
    },
    copyUrl() {
      this.$refs.url.setAttribute('type', 'text')
      this.$refs.url.select();
      document.execCommand("copy");
      this.$refs.url.setAttribute('type', 'hidden')
    }
  },
  watch: {
    'shareUrl': {
      immediate: true,
      handler: function() {
        this.updateUrl();
      }
    }
  }
};
</script>

<style lang="scss">
  .share-url {
    cursor: pointer;
  }
  .share-btn-list{
    a{
      margin-bottom: $int-space-xs;
    }
  }
</style>
